import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getPhotoPageDetailDataRequest, getPhotoImageByPositionRequest } from "../api/photo-api"
import Stack from "@mui/material/Stack";
import IconButton from "@mui/material/IconButton";
import ArrowBackIosNewRounded from "@mui/icons-material/ArrowBackIosNewRounded";
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';

const PhotoDetail = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { year = "", set = "", position = "" } = useParams<{ year: string; set: string, position: string }>();
    const [title, setTitle] = useState<string | undefined>(undefined);
    const [imageSrc, setImageSrc] = useState<string | undefined>(undefined);
    const [maxPosition, setMaxPosition] = useState<number>(0);
    const [currentPosition, setCurrentPosition] = useState<number>(Number(position));
    

    const fetchImage = async (pos: number) => {
        try {
            const data = await getPhotoImageByPositionRequest(year, set, pos.toString());
            const objectUrl = URL.createObjectURL(data);
            setImageSrc(objectUrl);
        } catch (err: any) {
            
        }
    };

    useEffect(() => {
        const fetchPageData = async () => {
            try {
                const data = await getPhotoPageDetailDataRequest(year, set);
                setTitle(data.title ?? t(data.titleKey));
                setMaxPosition(data.imageCount);
            } catch (err: any) {
                
            }
        };

        fetchPageData();
    }, [year, set, position]);

    useEffect(() => {
        fetchImage(currentPosition);
    }, [currentPosition]);


    const handleBack = () => {
        navigate(`/photos/${year}/${set}`);
    };

    const handleMove = (increment: number) => {
        let newPosition = currentPosition + increment;

        if (newPosition < 1) newPosition = 1;
        if (newPosition > maxPosition) newPosition = maxPosition;

        setCurrentPosition(newPosition);
        fetchImage(newPosition);
    };

    const moveFirst = () => {
        handleMove(-maxPosition);
    };

    const movePrior = () => {
        handleMove(-1);
    };

    const moveNext = () => {
        handleMove(1);
    };

    const moveLast = () => {
        handleMove(maxPosition);
    };

    return (
        <>
            <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 2 }}>
                <IconButton onClick={handleBack}>
                    <ArrowBackIosNewRounded />
                </IconButton>
                <h2 style={{ margin: 0 }}>{title}</h2>
            </Stack>
            <Stack direction="row" alignItems="center" justifyContent="center" width="100%">
                <IconButton onClick={moveFirst}>
                    <KeyboardDoubleArrowLeftIcon />
                </IconButton>
                <IconButton onClick={movePrior}>
                    <KeyboardArrowLeftIcon />
                </IconButton>
                <IconButton onClick={moveNext} sx={{marginLeft: 5}}>
                    <KeyboardArrowRightIcon />
                </IconButton>
                <IconButton onClick={moveLast}>
                    <KeyboardDoubleArrowRightIcon />
                </IconButton>
            </Stack>
            <Stack direction="column" alignItems="center" width="100%">
                <img
                src={imageSrc}
                alt=""
                style={{ width: "100%", maxWidth: "1200px", height: "auto", objectFit: "contain" }}
                />
            </Stack>
        </>
    );
};

export default PhotoDetail;